import type { Product } from './products';

export const extraProducts: Product[] = [
  // ─── Phones & Tablets (Cat 2) ─── extra accessories & budget phones
  {
    id: 'p85',
    name: 'Tempered Glass Screen Protector - iPhone 15 Pro Max',
    slug: 'tempered-glass-screen-protector-iphone-15-pro-max',
    description: '9H hardness tempered glass with oleophobic coating, bubble-free installation kit included, case-friendly edge design.',
    price: 999,
    salePrice: 599,
    sku: 'ACC-SP-IP15PM',
    stock: 456,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'ShieldPro',
    images: [
      'https://readdy.ai/api/search-image?query=Tempered%20glass%20screen%20protector%20for%20iPhone%20packaged%20in%20retail%20box%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-screenguard-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 567,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 3400,
    createdAt: '2026-02-01',
    tags: ['accessory', 'screen-protectors', 'phone', 'cases-sleeves'],
  },
  {
    id: 'p86',
    name: 'Silicone Shockproof Phone Case - Galaxy S24 Ultra Black',
    slug: 'silicone-shockproof-case-samsung-galaxy-s24-ultra',
    description: 'Flexible TPU bumper with reinforced corners, raised camera lip, precise cutouts, anti-slip grip texture, military-grade drop protection.',
    price: 1299,
    salePrice: 799,
    sku: 'ACC-CS-S24U-BK',
    stock: 345,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'CaseArmor',
    images: [
      'https://readdy.ai/api/search-image?query=Silicone%20shockproof%20phone%20case%20for%20Samsung%20Galaxy%20S24%20Ultra%20in%20black%20color%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-phonecase-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 345,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 2100,
    createdAt: '2026-03-01',
    tags: ['cases-sleeves', 'accessory', 'phone', 'samsung'],
  },
  {
    id: 'p87',
    name: 'Nokia 105 4G Feature Phone - Charcoal Black',
    slug: 'nokia-105-4g-feature-phone-charcoal-black',
    description: 'Compact 4G feature phone with 1.8-inch display, FM radio, MP3 player, long-lasting 1450mAh battery, dual SIM, torch light.',
    price: 2499,
    salePrice: 1799,
    sku: 'NOK-105-4G-BK',
    stock: 234,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'Nokia',
    images: [
      'https://readdy.ai/api/search-image?query=Nokia%20105%204G%20feature%20phone%20in%20charcoal%20black%20color%20front%20view%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-featurephone-01&orientation=squarish',
    ],
    rating: 4.0,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 5600,
    createdAt: '2026-01-10',
    tags: ['feature-phones', 'nokia', 'budget', 'phone'],
  },
  {
    id: 'p88',
    name: 'Samsung 25W USB-C Super Fast Wall Charger',
    slug: 'samsung-25w-usb-c-super-fast-wall-charger',
    description: 'Official Samsung 25W super fast charging adapter with USB-C output, compatible with Galaxy S24 and all USB-C devices, built-in safety protections.',
    price: 2499,
    salePrice: 1799,
    sku: 'ACC-CHG-SAM25W',
    stock: 189,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'Samsung',
    images: [
      'https://readdy.ai/api/search-image?query=Samsung%2025%20watt%20USB%20C%20super%20fast%20wall%20charger%20in%20white%20color%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-charger-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 456,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 3400,
    createdAt: '2026-02-15',
    tags: ['wall-chargers', 'accessory', 'samsung', 'charger'],
  },

  // ─── Health & Beauty (Cat 5) ─── makeup, hair color, more personal care
  {
    id: 'p89',
    name: 'MAC Matte Lipstick - Ruby Woo Red',
    slug: 'mac-matte-lipstick-ruby-woo-red',
    description: 'Iconic vivid blue-red matte lipstick, long-wearing 10-hour formula, non-feathering, non-bleeding, creamy texture that stays put all day.',
    price: 3499,
    salePrice: 2799,
    sku: 'MAC-LIP-RW',
    stock: 123,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'MAC',
    images: [
      'https://readdy.ai/api/search-image?query=MAC%20matte%20lipstick%20in%20Ruby%20Woo%20red%20color%20bullet%20tube%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-lipstick-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 890,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 4500,
    createdAt: '2026-01-15',
    tags: ['lip-makeup', 'makeup', 'beauty', 'women', 'mac'],
  },
  {
    id: 'p90',
    name: 'Maybelline Fit Me Liquid Foundation - Warm Nude 128',
    slug: 'maybelline-fit-me-foundation-warm-nude-128',
    description: 'Oil-free liquid foundation with SPF 18, natural matte finish, medium coverage, pore-minimizing micro-powders for a flawless complexion.',
    price: 1999,
    salePrice: 1499,
    sku: 'MAY-FM-WN128',
    stock: 178,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'Maybelline',
    images: [
      'https://readdy.ai/api/search-image?query=Maybelline%20Fit%20Me%20liquid%20foundation%20bottle%20Warm%20Nude%20shade%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-foundation-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 678,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 3400,
    createdAt: '2026-02-10',
    tags: ['face-makeup', 'makeup', 'beauty', 'women', 'maybelline'],
  },
  {
    id: 'p91',
    name: 'Dark & Lovely Permanent Hair Color - Jet Black 1.0',
    slug: 'dark-lovely-permanent-hair-color-jet-black',
    description: 'Ammonia-free permanent hair color with shea butter and avocado oil, full grey coverage, radiant shine, gentle on scalp and hair.',
    price: 899,
    salePrice: 649,
    sku: 'DAL-HC-JB',
    stock: 267,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'Dark & Lovely',
    images: [
      'https://readdy.ai/api/search-image?query=Dark%20and%20Lovely%20permanent%20hair%20color%20jet%20black%20box%20packaging%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-haircolor-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 456,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 2340,
    createdAt: '2026-03-01',
    tags: ['hair-color', 'hair-care', 'beauty', 'women'],
  },
  {
    id: 'p92',
    name: 'Nivea Men Deep Charcoal Face Wash - 150ml',
    slug: 'nivea-men-deep-charcoal-face-wash-150ml',
    description: 'Activated charcoal formula deeply cleanses pores, removes excess oil and impurities, fights blackheads for visibly clearer skin, suitable for daily use.',
    price: 1099,
    salePrice: 799,
    sku: 'NIV-DCFW-150',
    stock: 345,
    categoryId: '5',
    categoryName: 'Health & Beauty',
    storeName: 'BeautyCorner KE',
    brand: 'Nivea',
    images: [
      'https://readdy.ai/api/search-image?query=Nivea%20Men%20deep%20charcoal%20face%20wash%20tube%20black%20packaging%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-charcoal-fw-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 567,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 3400,
    createdAt: '2026-01-20',
    tags: ['face-care', 'skincare', 'men', 'nivea', 'beauty'],
  },

  // ─── Home & Office (Cat 6) ─── more furniture, decor, storage
  {
    id: 'p93',
    name: 'Ergonomic Mesh Office Chair - Adjustable Lumbar Support',
    slug: 'ergonomic-mesh-office-chair-adjustable-lumbar',
    description: 'Breathable mesh back with adjustable lumbar support, 3D armrests, tilt-lock mechanism, high-density foam seat, heavy-duty base with smooth casters.',
    price: 19999,
    salePrice: 15999,
    sku: 'FUR-OCH-MESH',
    stock: 45,
    categoryId: '6',
    categoryName: 'Home & Office',
    storeName: 'HomeEssentials KE',
    brand: 'WorkSpace',
    images: [
      'https://readdy.ai/api/search-image?query=Ergonomic%20mesh%20office%20chair%20with%20adjustable%20lumbar%20support%20black%20color%20front%20view%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-officechair-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 312,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 1200,
    createdAt: '2026-03-05',
    tags: ['office-chairs', 'office-furniture', 'furniture', 'home'],
  },
  {
    id: 'p94',
    name: 'Modern Abstract Wall Art Canvas Print - 3 Panel Set',
    slug: 'modern-abstract-wall-art-canvas-print-3-panel',
    description: 'Stretched canvas triptych with abstract geometric design, gallery-wrapped edges, ready to hang, fade-resistant inks, each panel 40x60cm, total width 120cm.',
    price: 5999,
    salePrice: 3999,
    sku: 'DEC-WART-3PC',
    stock: 78,
    categoryId: '6',
    categoryName: 'Home & Office',
    storeName: 'HomeEssentials KE',
    brand: 'ArtVibe',
    images: [
      'https://readdy.ai/api/search-image?query=Modern%20abstract%20wall%20art%20canvas%20print%203%20panel%20set%20with%20warm%20earth%20tone%20colors%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-wallart-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 234,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 890,
    createdAt: '2026-02-20',
    tags: ['wall-art', 'decor', 'home', 'art'],
  },
  {
    id: 'p95',
    name: 'Premium Non-Slip Area Rug - 160x230cm Grey',
    slug: 'premium-non-slip-area-rug-160x230-grey',
    description: 'Ultra-soft shaggy area rug with anti-slip backing, 40mm pile height, stain-resistant fibres, machine washable, ideal for living room and bedroom.',
    price: 7999,
    salePrice: 5499,
    sku: 'DEC-RUG-160-GR',
    stock: 56,
    categoryId: '6',
    categoryName: 'Home & Office',
    storeName: 'HomeEssentials KE',
    brand: 'SoftHome',
    images: [
      'https://readdy.ai/api/search-image?query=Premium%20non%20slip%20area%20rug%20160%20by%20230%20cm%20in%20grey%20color%20rolled%20up%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-rug-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 345,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 1340,
    createdAt: '2026-01-25',
    tags: ['rugs', 'decor', 'home', 'living-room'],
  },
  {
    id: 'p96',
    name: 'Foldable Storage Ottoman Bench - Dark Grey',
    slug: 'foldable-storage-ottoman-bench-dark-grey',
    description: 'Multi-functional storage ottoman with 100L capacity, padded seat, sturdy engineered wood frame, foldable lid, doubles as extra seating or footrest.',
    price: 5499,
    salePrice: 3999,
    sku: 'FUR-OTTB-DG',
    stock: 89,
    categoryId: '6',
    categoryName: 'Home & Office',
    storeName: 'HomeEssentials KE',
    brand: 'HomeStyle',
    images: [
      'https://readdy.ai/api/search-image?query=Foldable%20storage%20ottoman%20bench%20in%20dark%20grey%20color%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-ottoman-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 189,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 780,
    createdAt: '2026-03-10',
    tags: ['storage-boxes', 'furniture', 'home', 'living-room'],
  },

  // ─── Gaming (Cat 9) ─── headsets, mouse pads, VR
  {
    id: 'p97',
    name: 'Razer Kraken X Lite Gaming Headset - Black',
    slug: 'razer-kraken-x-lite-gaming-headset-black',
    description: 'Ultra-light 250g design with 7.1 surround sound, custom-tuned 40mm drivers, bendable cardioid microphone, cross-platform compatibility with 3.5mm jack.',
    price: 6999,
    salePrice: 4499,
    sku: 'RAZ-KRKNX-BK',
    stock: 89,
    categoryId: '9',
    categoryName: 'Gaming',
    storeName: 'GameZone Kenya',
    brand: 'Razer',
    images: [
      'https://readdy.ai/api/search-image?query=Razer%20Kraken%20X%20Lite%20gaming%20headset%20black%20color%20front%20view%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-gamingheadset-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 567,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 2340,
    createdAt: '2026-02-15',
    tags: ['gaming-headsets', 'gaming', 'headset', 'accessory'],
  },
  {
    id: 'p98',
    name: 'SteelSeries QcK Heavy Gaming Mouse Pad - Large',
    slug: 'steelseries-qck-heavy-gaming-mouse-pad-large',
    description: 'Extra thick 6mm cloth surface for maximum control, non-slip rubber base, optimized for optical and laser sensors, 450x400mm size fits all desk setups.',
    price: 3499,
    salePrice: 2499,
    sku: 'STS-QCK-HVY',
    stock: 234,
    categoryId: '9',
    categoryName: 'Gaming',
    storeName: 'GameZone Kenya',
    brand: 'SteelSeries',
    images: [
      'https://readdy.ai/api/search-image?query=SteelSeries%20QcK%20heavy%20gaming%20mouse%20pad%20large%20black%20color%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-mousepad-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 4500,
    createdAt: '2026-01-15',
    tags: ['mouse-pads', 'gaming', 'accessory', 'pc'],
  },
  {
    id: 'p99',
    name: 'Meta Quest 3S VR Headset - 128GB',
    slug: 'meta-quest-3s-vr-headset-128gb',
    description: 'Mixed reality headset with pancake lenses, Snapdragon XR2 Gen 2 processor, 4K+ Infinite Display, hand tracking, 2-3 hour battery for immersive VR gaming.',
    price: 49999,
    salePrice: 44999,
    sku: 'META-Q3S-128',
    stock: 12,
    categoryId: '9',
    categoryName: 'Gaming',
    storeName: 'GameZone Kenya',
    brand: 'Meta',
    images: [
      'https://readdy.ai/api/search-image?query=Meta%20Quest%203S%20VR%20headset%20128GB%20white%20color%20front%20view%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-vrheadset-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 234,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 345,
    createdAt: '2026-03-01',
    tags: ['vr-headsets', 'gaming', 'vr', 'meta'],
  },

  // ─── Supermarket (Cat 10) ─── pasta, juice, tea, detergent, toilet paper
  {
    id: 'p100',
    name: 'Golden Penny Spaghetti Pasta - 500g x 5 Pack',
    slug: 'golden-penny-spaghetti-pasta-500g-5-pack',
    description: 'Premium durum wheat spaghetti, enriched with iron and B vitamins, cooks in 10 minutes, perfect for jollof spaghetti and everyday meals.',
    price: 1299,
    salePrice: 999,
    sku: 'GRO-PASTA-5PK',
    stock: 567,
    categoryId: '10',
    categoryName: 'Supermarket',
    storeName: 'GroceryMart Kenya',
    brand: 'Golden Penny',
    images: [
      'https://readdy.ai/api/search-image?query=Golden%20Penny%20spaghetti%20pasta%20500%20gram%20pack%20of%205%20yellow%20packaging%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-pasta-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 6700,
    createdAt: '2026-01-05',
    tags: ['pasta-noodles', 'food', 'supermarket', 'cooking'],
  },
  {
    id: 'p101',
    name: 'Del Monte Pineapple Juice - 1 Litre x 6 Pack',
    slug: 'del-monte-pineapple-juice-1-litre-6-pack',
    description: '100 percent pure pineapple juice with no added sugar, rich in Vitamin C, refreshing tropical taste, convenient resealable tetra pack.',
    price: 1899,
    salePrice: 1499,
    sku: 'BEV-DMPJ-6PK',
    stock: 345,
    categoryId: '10',
    categoryName: 'Supermarket',
    storeName: 'GroceryMart Kenya',
    brand: 'Del Monte',
    images: [
      'https://readdy.ai/api/search-image?query=Del%20Monte%20pineapple%20juice%201%20litre%20pack%20of%206%20tetra%20packs%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-juice-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 456,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 4500,
    createdAt: '2026-02-01',
    tags: ['juices', 'beverage', 'supermarket', 'food'],
  },
  {
    id: 'p102',
    name: 'Kericho Gold Premium Tea Bags - Pack of 100',
    slug: 'kericho-gold-premium-tea-bags-pack-100',
    description: 'Finest Kenyan highland tea, hand-picked and freshly packed, rich aroma with smooth full-bodied taste, individually wrapped tea bags for freshness.',
    price: 899,
    salePrice: 699,
    sku: 'BEV-TEA-KG100',
    stock: 567,
    categoryId: '10',
    categoryName: 'Supermarket',
    storeName: 'GroceryMart Kenya',
    brand: 'Kericho Gold',
    images: [
      'https://readdy.ai/api/search-image?query=Kericho%20Gold%20premium%20tea%20bags%20pack%20of%20100%20gold%20packaging%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-tea-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 1230,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 8900,
    createdAt: '2026-01-10',
    tags: ['tea-coffee', 'beverage', 'supermarket', 'food'],
  },
  {
    id: 'p103',
    name: 'OMO Multi-Action Laundry Detergent - 2kg',
    slug: 'omo-multi-action-laundry-detergent-2kg',
    description: 'Powerful stain removal with multi-action formula, works in cold water, suitable for hand wash and machine wash, fresh fragrance that lasts for days.',
    price: 899,
    salePrice: 699,
    sku: 'HH-OMO-2KG',
    stock: 456,
    categoryId: '10',
    categoryName: 'Supermarket',
    storeName: 'GroceryMart Kenya',
    brand: 'OMO',
    images: [
      'https://readdy.ai/api/search-image?query=OMO%20multi%20action%20laundry%20detergent%202%20kilogram%20pack%20blue%20and%20white%20packaging%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-detergent-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 1560,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 12000,
    createdAt: '2026-01-05',
    tags: ['laundry', 'detergents', 'household', 'supermarket'],
  },
  {
    id: 'p104',
    name: 'SoftCare Toilet Paper Roll - Pack of 24',
    slug: 'softcare-toilet-paper-roll-pack-24',
    description: '3-ply premium tissue with embossed texture, extra soft, high absorbency, septic-safe and biodegradable, 24 rolls lasting up to 2 months for a family.',
    price: 1499,
    salePrice: 1199,
    sku: 'HH-TP-SC24',
    stock: 567,
    categoryId: '10',
    categoryName: 'Supermarket',
    storeName: 'GroceryMart Kenya',
    brand: 'SoftCare',
    images: [
      'https://readdy.ai/api/search-image?query=SoftCare%20toilet%20paper%20roll%20pack%20of%2024%20white%20packaging%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-toiletpaper-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 8900,
    createdAt: '2026-01-15',
    tags: ['toilet-paper', 'household', 'supermarket', 'home'],
  },

  // ─── Baby Products (Cat 11) ─── wipes, food, toys, car seat
  {
    id: 'p105',
    name: 'Pampers Sensitive Baby Wipes - Pack of 12 x 56',
    slug: 'pampers-sensitive-baby-wipes-pack-12',
    description: 'Dermatologically tested baby wipes with 0 percent alcohol, enriched with soothing aloe vera, thick and gentle for delicate skin, resealable packaging.',
    price: 2499,
    salePrice: 1999,
    sku: 'BBY-WPS-12PK',
    stock: 345,
    categoryId: '11',
    categoryName: 'Baby Products',
    storeName: 'BabyJoy KE',
    brand: 'Pampers',
    images: [
      'https://readdy.ai/api/search-image?query=Pampers%20sensitive%20baby%20wipes%20pack%20of%2012%20green%20and%20white%20packaging%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-babywipes-01&orientation=squarish',
    ],
    rating: 4.7,
    reviewCount: 890,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 6700,
    createdAt: '2026-01-10',
    tags: ['wipes', 'baby-wipes', 'baby', 'baby-care'],
  },
  {
    id: 'p106',
    name: 'Cerelac Nutripuffs Banana Cereal Snack - 50g x 4',
    slug: 'cerelac-nutripuffs-banana-cereal-snack-50g-4pack',
    description: 'Melt-in-mouth banana flavored cereal snack for babies 8 months plus, enriched with iron and zinc, no artificial colors or preservatives, easy grip for self-feeding.',
    price: 1299,
    salePrice: 999,
    sku: 'BBY-FOOD-CER-BN',
    stock: 234,
    categoryId: '11',
    categoryName: 'Baby Products',
    storeName: 'BabyJoy KE',
    brand: 'Cerelac',
    images: [
      'https://readdy.ai/api/search-image?query=Cerelac%20Nutripuffs%20banana%20cereal%20snack%2050%20gram%20pack%20of%204%20yellow%20packaging%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-babyfood-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 456,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 3400,
    createdAt: '2026-02-01',
    tags: ['baby-food', 'feeding', 'baby', 'baby-care'],
  },
  {
    id: 'p107',
    name: 'Fisher-Price Laugh & Learn Smart Phone Toy',
    slug: 'fisher-price-laugh-learn-smart-phone-toy',
    description: 'Interactive baby smartphone toy with lights sounds and songs, teaches numbers colors and greetings, slider activates different responses, for 6 to 36 months.',
    price: 2499,
    salePrice: 1799,
    sku: 'BBY-TOY-FP-PHN',
    stock: 178,
    categoryId: '11',
    categoryName: 'Baby Products',
    storeName: 'BabyJoy KE',
    brand: 'Fisher-Price',
    images: [
      'https://readdy.ai/api/search-image?query=Fisher%20Price%20Laugh%20and%20Learn%20smart%20phone%20baby%20toy%20colorful%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-babytoy-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 678,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 2340,
    createdAt: '2026-03-01',
    tags: ['educational-toys', 'toys', 'baby', 'baby-care'],
  },
  {
    id: 'p108',
    name: 'Graco SnugRide 35 Infant Car Seat - Black',
    slug: 'graco-snugride-35-infant-car-seat-black',
    description: 'Rear-facing infant car seat for 2 to 16kg, side impact tested, easy-adjust 5-point harness, removable infant insert, compatible with Graco strollers.',
    price: 24999,
    salePrice: 19999,
    sku: 'BBY-CS-SR35-BK',
    stock: 34,
    categoryId: '11',
    categoryName: 'Baby Products',
    storeName: 'BabyJoy KE',
    brand: 'Graco',
    images: [
      'https://readdy.ai/api/search-image?query=Graco%20SnugRide%2035%20infant%20car%20seat%20black%20color%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-carseat-01&orientation=squarish',
    ],
    rating: 4.8,
    reviewCount: 234,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 567,
    createdAt: '2026-02-10',
    tags: ['car-seats', 'baby', 'baby-care', 'safety'],
  },

  // ─── Other Categories (Cat 12) ─── garden, automotive, sports, camping
  {
    id: 'p109',
    name: 'Garden Tool Set 6-Piece with Storage Bag',
    slug: 'garden-tool-set-6-piece-storage-bag',
    description: 'Heavy-duty stainless steel garden tools including trowel, transplanter, cultivator, weeder, pruning shears and gloves, ergonomic soft-grip handles, storage tote included.',
    price: 4499,
    salePrice: 2999,
    sku: 'GDN-TL6-SET',
    stock: 89,
    categoryId: '12',
    categoryName: 'Other categories',
    storeName: 'BuildMart KE',
    brand: 'GardenPro',
    images: [
      'https://readdy.ai/api/search-image?query=Garden%20tool%20set%206%20piece%20with%20storage%20bag%20stainless%20steel%20tools%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-gardentools-01&orientation=squarish',
    ],
    rating: 4.3,
    reviewCount: 345,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 1200,
    createdAt: '2026-03-10',
    tags: ['garden-tools', 'garden', 'tools', 'outdoor'],
  },
  {
    id: 'p110',
    name: 'Pioneer Car Bluetooth FM Transmitter - Dual USB',
    slug: 'pioneer-car-bluetooth-fm-transmitter-dual-usb',
    description: 'Wireless Bluetooth 5.0 FM transmitter for car, hands-free calling, dual USB charging ports with 3.1A fast charge, LED display, supports USB flash drive and microSD card.',
    price: 2999,
    salePrice: 1999,
    sku: 'AUT-FMT-BT5',
    stock: 234,
    categoryId: '12',
    categoryName: 'Other categories',
    storeName: 'BuildMart KE',
    brand: 'Pioneer',
    images: [
      'https://readdy.ai/api/search-image?query=Pioneer%20car%20bluetooth%20FM%20transmitter%20with%20dual%20USB%20charging%20black%20color%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-fmtransmitter-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 678,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 3400,
    createdAt: '2026-02-15',
    tags: ['car-electronics', 'automotive', 'accessory', 'bluetooth'],
  },
  {
    id: 'p111',
    name: 'Mountain Bike 26-inch 21-Speed Shimano Gears - Black',
    slug: 'mountain-bike-26-inch-21-speed-shimano-black',
    description: 'Aluminum alloy frame mountain bike, 21-speed Shimano gears, front suspension fork, dual disc brakes, 26-inch knobby tyres, includes kickstand and reflectors.',
    price: 24999,
    salePrice: 19999,
    sku: 'SPT-BIKE-26-21S',
    stock: 23,
    categoryId: '12',
    categoryName: 'Other categories',
    storeName: 'BuildMart KE',
    brand: 'TrekPro',
    images: [
      'https://readdy.ai/api/search-image?query=Mountain%20bike%2026%20inch%2021%20speed%20Shimano%20gears%20black%20color%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-bike-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 189,
    featured: true,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 456,
    createdAt: '2026-03-01',
    tags: ['cycling', 'sports', 'fitness', 'outdoor'],
  },
  {
    id: 'p112',
    name: '3-Person Camping Tent - Waterproof Dome',
    slug: '3-person-camping-tent-waterproof-dome',
    description: 'Easy setup 3-person dome tent with waterproof PU2000 flysheet, taped seams, ventilation windows, mosquito mesh, built-in storage pockets, includes carry bag and stakes.',
    price: 8999,
    salePrice: 6499,
    sku: 'SPT-TENT-3P',
    stock: 45,
    categoryId: '12',
    categoryName: 'Other categories',
    storeName: 'BuildMart KE',
    brand: 'CampPro',
    images: [
      'https://readdy.ai/api/search-image?query=3%20person%20camping%20tent%20waterproof%20dome%20green%20color%20set%20up%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-tent-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 234,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 780,
    createdAt: '2026-02-20',
    tags: ['camping', 'sports', 'outdoor', 'travel'],
  },
  {
    id: 'p113',
    name: 'Dumbbell Set 20kg Pair with Adjustable Weights',
    slug: 'dumbbell-set-20kg-pair-adjustable-weights',
    description: '20kg adjustable dumbbell set (2 x 10kg), cast iron plates with chrome bar, spin-lock collars, non-slip knurled grip, includes storage tray, ideal for home gym.',
    price: 7999,
    salePrice: 5999,
    sku: 'SPT-DB20-SET',
    stock: 67,
    categoryId: '12',
    categoryName: 'Other categories',
    storeName: 'BuildMart KE',
    brand: 'IronGrip',
    images: [
      'https://readdy.ai/api/search-image?query=Dumbbell%20set%2020%20kilogram%20pair%20with%20adjustable%20cast%20iron%20weights%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-dumbbell-01&orientation=squarish',
    ],
    rating: 4.6,
    reviewCount: 456,
    featured: true,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 1890,
    createdAt: '2026-01-20',
    tags: ['fitness', 'sports', 'exercise', 'home'],
  },

  // ─── Phones & Tablets extras ─── another tablet accessory
  {
    id: 'p114',
    name: 'Universal Tablet Stand - Foldable Aluminum',
    slug: 'universal-tablet-stand-foldable-aluminum',
    description: 'Adjustable aluminum tablet stand compatible with all tablets 7 to 13 inches, 6 height angles, anti-slip silicone pads, foldable for portability, ideal for desk and kitchen.',
    price: 2499,
    salePrice: 1799,
    sku: 'ACC-TB-STAND-AL',
    stock: 189,
    categoryId: '2',
    categoryName: 'Phones & Tablets',
    storeName: 'TechHub Kenya',
    brand: 'StandPro',
    images: [
      'https://readdy.ai/api/search-image?query=Universal%20tablet%20stand%20foldable%20aluminum%20silver%20color%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-stand-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 345,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 2100,
    createdAt: '2026-02-10',
    tags: ['stands', 'tablet-accessories', 'accessory', 'tablet'],
  },

  // ─── Computing extras ─── USB hub
  {
    id: 'p115',
    name: 'UGREEN 7-in-1 USB-C Hub - HDMI 4K Card Reader',
    slug: 'ugreen-7-in-1-usb-c-hub-hdmi-4k',
    description: 'Compact USB-C hub with 4K HDMI output, 3 USB 3.0 ports, SD and microSD card slots, 100W PD pass-through charging, aluminum body for heat dissipation.',
    price: 5999,
    salePrice: 3999,
    sku: 'ACC-HUB-UG7IN1',
    stock: 145,
    categoryId: '8',
    categoryName: 'Computing',
    storeName: 'TechHub Kenya',
    brand: 'UGREEN',
    images: [
      'https://readdy.ai/api/search-image?query=UGREEN%207%20in%201%20USB%20C%20hub%20with%20HDMI%204K%20card%20reader%20gray%20aluminum%20body%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-usbhub-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 567,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 2340,
    createdAt: '2026-02-01',
    tags: ['usb-hubs', 'accessory', 'computing', 'laptop'],
  },

  // ─── Appliances extras ─── toaster
  {
    id: 'p116',
    name: 'Nunix 2-Slice Pop-Up Toaster - 750W White',
    slug: 'nunix-2-slice-pop-up-toaster-750w-white',
    description: 'Compact 2-slice toaster with 6 browning settings, defrost and reheat functions, removable crumb tray, auto shut-off, cool-touch exterior for safe handling.',
    price: 2499,
    salePrice: 1799,
    sku: 'NUN-TSTR-2S-WH',
    stock: 167,
    categoryId: '4',
    categoryName: 'Appliances',
    storeName: 'HomeEssentials KE',
    brand: 'Nunix',
    images: [
      'https://readdy.ai/api/search-image?query=Nunix%202%20slice%20pop%20up%20toaster%20750%20watt%20white%20color%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-toaster-01&orientation=squarish',
    ],
    rating: 4.2,
    reviewCount: 345,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-28T23:59:59Z',
    soldCount: 2100,
    createdAt: '2026-01-25',
    tags: ['toasters', 'kitchen', 'appliance', 'cooking'],
  },

  // ─── Fashion extras ─── sandals, wallet
  {
    id: 'p117',
    name: 'Men Leather Slide Sandals - Brown',
    slug: 'men-leather-slide-sandals-brown',
    description: 'Genuine leather upper with contoured footbed, slip-resistant rubber sole, double-stitched strap, perfect for casual outings and beach days.',
    price: 2999,
    salePrice: 1999,
    sku: 'FAS-SDL-BR-42',
    stock: 189,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'SneakerHead Kenya',
    brand: 'FootPride',
    images: [
      'https://readdy.ai/api/search-image?query=Men%20leather%20slide%20sandals%20brown%20color%20top%20view%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-sandals-01&orientation=squarish',
    ],
    rating: 4.1,
    reviewCount: 234,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-29T23:59:59Z',
    soldCount: 1200,
    createdAt: '2026-03-15',
    tags: ['sandals', 'shoes', 'men', 'summer'],
  },
  {
    id: 'p118',
    name: 'Men Genuine Leather Bi-Fold Wallet - Dark Brown',
    slug: 'men-genuine-leather-bi-fold-wallet-dark-brown',
    description: 'Classic bi-fold wallet crafted from full-grain leather, 8 card slots, 2 bill compartments, ID window, RFID blocking layer for security, gift box included.',
    price: 2999,
    salePrice: 1999,
    sku: 'FAS-WLT-BF-DB',
    stock: 234,
    categoryId: '7',
    categoryName: 'Fashion',
    storeName: 'FashionForward KE',
    brand: 'LeatherCraft',
    images: [
      'https://readdy.ai/api/search-image?query=Men%20genuine%20leather%20bi%20fold%20wallet%20dark%20brown%20color%20open%20showing%20card%20slots%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-wallet-01&orientation=squarish',
    ],
    rating: 4.4,
    reviewCount: 456,
    featured: false,
    flashDeal: false,
    flashDealEnds: null,
    soldCount: 2340,
    createdAt: '2026-01-10',
    tags: ['wallets', 'accessory', 'men', 'leather'],
  },

  // ─── Baby extras ─── baby clothing
  {
    id: 'p119',
    name: 'Newborn Baby Bodysuit Cotton - 5-Pack White',
    slug: 'newborn-baby-bodysuit-cotton-5-pack-white',
    description: '100 percent organic cotton newborn bodysuits, envelope neck for easy dressing, snap bottom closure for quick diaper changes, sizes 0-3 months, gentle on sensitive skin.',
    price: 2499,
    salePrice: 1799,
    sku: 'BBY-CL-BDY-5PK',
    stock: 234,
    categoryId: '11',
    categoryName: 'Baby Products',
    storeName: 'BabyJoy KE',
    brand: 'TinyWear',
    images: [
      'https://readdy.ai/api/search-image?query=Newborn%20baby%20bodysuit%20cotton%205%20pack%20white%20color%20folded%20on%20clean%20white%20background%2C%20product%20photography%2C%20minimal%20setup%2C%20professional%20lighting%20soft%20shadows&width=600&height=600&seq=prod-bodysuit-01&orientation=squarish',
    ],
    rating: 4.5,
    reviewCount: 345,
    featured: false,
    flashDeal: true,
    flashDealEnds: '2026-06-30T23:59:59Z',
    soldCount: 3400,
    createdAt: '2026-02-01',
    tags: ['bodysuits', 'newborn', 'baby', 'baby-care'],
  },
];